

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
  take,
  takeUntil,
  Subject,
  lastValueFrom,
  firstValueFrom,
  skip,
} from 'rxjs';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import {
  ExtendedKeycloakUser,
  PurchaseType,
  StoreDropdowns,
  UserInformation,
} from 'src/app/shared/models/app-models';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { PageEvent } from '@angular/material/paginator';
import { clearTaggingStore } from 'src/app/core/store/TaggedVendors.action';
import { clearAttachmentStore } from 'src/app/core/store/attachment.action';
import { clearStore } from 'src/app/core/store/form.actions';
import { clearDeletedItemVendorStore } from 'src/app/core/store/DeletedItemVendors.action';
import { DatePipe } from '@angular/common';
import { MyPEWorkListData, MyPEWorklist, VendorNames } from 'src/app/shared/models/database-models/MyWorklist.model';
import { pageName } from 'src/app/shared/services/page.service';
import PelistingAction from 'src/app/data/constants/PelistingAction.json';

export interface RoutingToCE {
  RoutingToCE: boolean
}
@Component({
  selector: 'app-pe-worklist-listing',
  templateUrl: './pe-worklist-listing.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
  styleUrls: ['./pe-worklist-listing.component.scss'],
  providers: [
    {
      provide: DatePipe,
    }
  ],
})
export class PeWorklistListingComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild(MatSort) sort!: MatSort;
  @Input() tabStatus: string = '';
  @Input() index!: number;
  @Input() selectedIndex!: number;
  @Input() initialData: MyPEWorklist[] = [];
  @Input() badgeCount: number = 0;
  @Output() reloadEvent = new EventEmitter<void>();
  isLoadingData: boolean = true;
  peToDoDocuments: MyPEWorklist[] = [];
  dataSource: MatTableDataSource<MyPEWorklist> =
    new MatTableDataSource<MyPEWorklist>(this.peToDoDocuments);
  wlColumnsToDisplay = [
    'NextAction',
    'MPDocumentNumber',
    'RFQNumber',
    'RFQClosingDate',
    'VendorNames',
    'OpenItems',
    'ItemDescription',
    'PurchaseMode',
    'ROName',
    'WorklistDateCreated',
  ];
  columnsToDisplayWithExpand: string[] = ['expand', ...this.wlColumnsToDisplay];
  expandedElement!: MyPEWorklist | null;
  destroy$: Subject<boolean> = new Subject<boolean>();
  userList: ExtendedKeycloakUser[] = [];
  user!: UserInformation;
  pageSize: number = 20;
  emptyMessage: string = '';
  pageSizeOptions: number[] = [20, 40, 60];
  currentPage: number = 0;
  totalCount: number = 0;
  sortSettingMap: any = {};
  currentSort: string | null = null;
  pageName = pageName;
  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private store: Store<{ dp: StoreDropdowns; user: UserInformation }>,
    private backendService: BackendApiService
  ) {
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.userList = dp.UserList as ExtendedKeycloakUser[];
      });
    this.store
      .select('user')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (user: UserInformation) => {
        this.user = user;
      });
    this.initSort()
  }
  async ngOnInit(): Promise<void> {


    this.dataSource.filterPredicate = (data: any, filter: string) => {
      if (data.VendorNames && Array.isArray(data.VendorNames)) {
        return data.VendorNames.some((vendor: VendorNames) =>
          vendor.Name.toLowerCase().includes(filter)
        );
      }
      return false;
    };
    this.dataSource.filterPredicate = (data: MyPEWorklist, filter: string): boolean => {
      const matchVendorNames = data.VendorNames.some((vendor: VendorNames) =>
        vendor.Name.toLowerCase().includes(filter)
      );
      const matchRFQnumber = data.RFQNumber?.toLowerCase().includes(filter);
      const matchMPDocumentNumber = data.MPDocumentNumber.toLowerCase().includes(filter);

      const formattedDate = this.datePipe.transform(data.RFQClosingDate, 'dd/MM/yyyy');
      const matchRFQClosingDate = formattedDate?.includes(filter);

      const matchOpenItems = data.OpenItems?.includes(filter);
      const matchItemDescription = data.ItemDescription ? data.ItemDescription.toLowerCase().includes(filter) : false;
      const matchItemPurchaseMode = data.PurchaseMode?.toLowerCase().includes(filter);
      const matchItemROName = data.ROName?.toLowerCase().includes(filter);

      const formattedDWorklistDate = this.datePipe.transform(data.WorklistDateCreated, 'dd/MM/yyyy');
      const matchWorklistDateCreated = formattedDWorklistDate?.includes(filter);

      return (matchVendorNames
        || matchRFQnumber
        || matchMPDocumentNumber
        || matchRFQClosingDate
        || matchOpenItems
        || matchItemDescription
        || matchItemPurchaseMode
        || matchItemROName
        || (matchWorklistDateCreated !== undefined ? matchWorklistDateCreated : false)
      )
    };
    this.store.dispatch(clearStore());
    this.store.dispatch(clearTaggingStore());
    this.store.dispatch(clearDeletedItemVendorStore())
    this.store.dispatch(clearAttachmentStore());
  }
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.isLoadingData = true;
    // await this.loadDataBasedOnPageAndLimit();
    await this.loadDataBasedOnPageAndLimit(this.initialData);
    this.isLoadingData = false;
  }
  toggleRowHeight(element: any) {
    if ((element['ItemDescription'] && element['ItemDescription'].length >= 50) || element['OpenItems'] && element['OpenItems'].length >= 30) {
      if (this.expandedElement === element) {
        this.expandedElement = null;
      } else {
        this.expandedElement = element;
      }
    }

  }

  async loadDataBasedOnPageAndLimit(initialData?: MyPEWorklist[]) {
    if (this.tabStatus === 'ToDo') {
      if (!initialData) {
        let data: MyPEWorkListData = await lastValueFrom(
          this.backendService.getTodoPeWorklist(
            this.pageSize.toString(),
            (this.currentPage + 1).toString(),
            this.currentSort ? this.currentSort : 'WorklistDateCreated',
            this.currentSort ? this.sortSettingMap[this.currentSort] : false
          )
        );

        this.peToDoDocuments = data.Data.map((docs: MyPEWorklist) => {
          return {
            ...docs,
            ROName: this.userList.find((user) => user.id == docs.ROName)?.last_name ?? '',
            ActionId: PelistingAction.find(action => action.ActionName === docs.NextAction?.Name)?.ActionId || null
          };
        });

        this.dataSource.data = this.peToDoDocuments;
        this.totalCount = data.TotalCount;
      } else {
        this.peToDoDocuments = initialData.map((docs: MyPEWorklist) => {
          return {
            ...docs,
            ROName: this.userList.find((user) => user.id == docs.ROName)?.last_name ?? '',
            ActionId: PelistingAction.find(action => action.ActionName === docs.NextAction?.Name)?.ActionId || null
          };
        });
        this.dataSource.data = this.peToDoDocuments;
        this.totalCount = this.badgeCount;
      }


      setTimeout(() => {
        this.isLoadingData = false;
        if (this.totalCount == 0) this.getEmptyMessage(this.index);
      }, 100);
    } else {
      if (!initialData) {
        let data: MyPEWorkListData = await lastValueFrom(
          this.backendService.getDonePeWorklist(
            this.pageSize.toString(),
            (this.currentPage + 1).toString(),
            this.currentSort ? this.currentSort : 'WorklistDateCreated',
            this.currentSort ? this.sortSettingMap[this.currentSort] : false
          )
        );
        this.peToDoDocuments = data.Data.map((docs: MyPEWorklist) => {
          return {
            ...docs,
            ROName: this.userList.find((user) => user.id == docs.ROName)?.last_name ?? '',
            ActionId: PelistingAction.find(action => action.ActionName === docs.NextAction?.Name)?.ActionId || null
          };
        });
        this.dataSource.data = this.peToDoDocuments;
        this.totalCount = data.TotalCount;
      } else {
        this.peToDoDocuments = initialData.map((docs: MyPEWorklist) => {
          return {
            ...docs,
            ROName: this.userList.find((user) => user.id == docs.ROName)?.last_name ?? '',
            ActionId: PelistingAction.find(action => action.ActionName === docs.NextAction?.Name)?.ActionId || null
          };
        });
        this.dataSource.data = this.peToDoDocuments;
        this.totalCount = this.badgeCount;
      }


      setTimeout(() => {
        this.isLoadingData = false;
        if (this.totalCount == 0) this.getEmptyMessage(this.index);
      }, 100);
    }

  }

  async onPageChange(event: PageEvent) {
    // console.log('onPageChange', event);
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    await this.loadDataBasedOnPageAndLimit();
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  formatHeader(camelCaseHeader: string): string {
    const words = camelCaseHeader
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, function (str) {
        return str.toUpperCase();
      });
    if (words.trim().toLowerCase() === 'm p document number') {
      return 'Document no.';
    }
    if (words.trim().toLowerCase() === 'modified on') {
      return 'Last Modified Date';
    }
    if (words.trim().toLowerCase() === 'r f q number') {
      return 'RFQ Number';
    }
    if (words.trim().toLowerCase() === 'r f q closing date') {
      return 'RFQ Closing Date';
    }
    if (words.trim().toLowerCase() === 'open items') {
      return 'Open MP Item No';
    }
    if (words.trim().toLowerCase() === 'r o name') {
      return 'MP Requesting Officer';
    }
    if (words.trim().toLowerCase() === 'next action') {

      return this.tabStatus === 'ToDo' ? 'Next Action' : 'Action taken';
    }
    return words;
  }
  getRouteToRoView(purchaseMode: PurchaseType, DocumentNo: string) {
    let url = ''
    switch (purchaseMode) {
      case PurchaseType.RFQ:
        url = '/purchase/rfq/' + `${DocumentNo}`;
        break;
      case PurchaseType.TENDER:
        url = '/purchase/tender/' + `${DocumentNo}`;
        break;
      case PurchaseType.CORPORATE_CARD:
        url = '/purchase/corporatecard/' + `${DocumentNo}`;
        break;
      case PurchaseType.PM:
        url = '/purchase/permissiblecoveringpurchaseorder/' + `${DocumentNo}`;
        break;
      case PurchaseType.DC:
        url = '/purchase/dc/' + `${DocumentNo}`;
        break;
      case PurchaseType.ONLINE:
        url = '/purchase/corporatecard/' + `${DocumentNo}`;
        break;
    }
    window.open(url, '_blank');
    return;
  }
  getEmptyMessage(tabIndex: number) {
    switch (tabIndex) {
      case 0:
        this.emptyMessage = 'You have no todo document items.';
        break;
      case 1:
        this.emptyMessage = 'You have no completed document items.';
        break;
      default:
        this.emptyMessage = 'You have no document items.';
    }
  }

  initSort() {
    for (const column of this.wlColumnsToDisplay) {
      this.sortSettingMap[column] = true;
    }
  }


  resetSort(columnToSort: string) {
    for (const column of this.wlColumnsToDisplay) {
      if (column != columnToSort) {
        this.sortSettingMap[column] = true;
      }
    }
  }

  sortByColumn(column: string) {
    if (this.currentSort != column) {
      this.resetSort(column);
      this.currentSort = column;
    } else {
      this.sortSettingMap[column] = !this.sortSettingMap[column];
    }
    // api call to update order
    this.loadDataBasedOnPageAndLimit();
  }


  async MarkasDone(items: MyPEWorklist) {
    this.isLoadingData = true;
    try {
      const markAsDoneRequest = {
        Action: items.NextAction.Name,
        MPDocumentNumber: items.MPDocumentNumber,
        RFQNumber: items.RFQNumber,
        WorklistDateCreated: items.WorklistDateCreated
      }
      const response = await lastValueFrom(this.backendService.markAsDone(markAsDoneRequest));
      // await this.loadDataBasedOnPageAndLimit();
      this.reloadEvent.emit();
      this.isLoadingData = false;
    } catch (err: any) {
      this.isLoadingData = false;
      console.log('the err for mark as done items : ', err);
    }
  }

  getUniqueItems(openItems: string): string {
    if (!openItems || openItems.trim() === '') {
      return '';
    }
    // If the string is a single item, just return it without splitting
    if (openItems.indexOf(',') === -1) {
      return openItems;
    }
    const itemsArray = openItems.split(',');
    const uniqueItemsArray = Array.from(new Set(itemsArray));
    return uniqueItemsArray.join(',');
  }

  
  createRFQSummary(item: MyPEWorklist) {
    const data = {
      MPDocumentNumber: item.MPDocumentNumber,
      RFQNumber: item.RFQNumber,
      fromRoute: pageName.PE_Worklist,
    };
    this.router.navigate(['/rfqSummary'], { state: { data: data } });
  }

  navigateToRFQSummary(item: MyPEWorklist) {
    sessionStorage.setItem('fromPage', pageName.PE_Worklist);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/rfqSummary/', item.RFQSummaryNumber])
    );
    window.open(url, '_blank');
  }
}
